import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../../base/components/AuthProvider';
import ActiveMembershipRequiredPopup from '../../components/ActiveMembershipRequiredPopup';
import { startConversation } from '../../../chat/components/Conversation/ConversationUtilities';

const WorkerProfileStartConversationView = ({ workerId, setSignUpVisible }) => {
  const { userData, authTokens } = useContext(AuthContext);
  const navigate = useNavigate();
  const [showMembershipPopup, setShowMembershipPopup] = useState(false);

  const handleStartConversation = async () => {
    if (!userData) {
      setSignUpVisible(true);
      return;
    }
    if (!userData.membership_status && userData.is_admin === false) {
      setShowMembershipPopup(true);
      return;
    }
    const { success, data, error } = await startConversation({
      authTokens,
      userData,
      workerId,
      parentId: userData.profile_id,
      adminId: null,
    });
    if (success) {
      navigate(`/conversations/chat/${data.id}`);
    } else {
      console.error('Error al iniciar la conversación:', error);
    }
  };

  if (userData && userData.profile_type === 'Worker') {
    return null;
  }

  return (
    <div className="start-conversation-container">
      <button className="primary-btn" onClick={handleStartConversation}>
        Chatear
      </button>
      {showMembershipPopup && (
        <ActiveMembershipRequiredPopup onClose={() => setShowMembershipPopup(false)} />
      )}
    </div>
  );
};

export default WorkerProfileStartConversationView;